'use client';

import { useEffect } from 'react';

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker?.register('/sw.js', { scope: '/' })?.then((registration) => {
            console.log('[Nova QR] Service Worker registered:', registration?.scope);

            // Check for updates periodically
            registration?.addEventListener('updatefound', () => {
              const newWorker = registration?.installing;
              if (newWorker) {
                newWorker?.addEventListener('statechange', () => {
                  if (
                    newWorker?.state === 'installed' &&
                    navigator.serviceWorker?.controller
                  ) {
                    // New version available — skip waiting and reload
                    newWorker?.postMessage({ type: 'SKIP_WAITING' });
                    window.location?.reload();
                  }
                });
              }
            });
          })?.catch((error) => {
            console.warn('[Nova QR] Service Worker registration failed:', error);
          });
      });
    }
  }, []);

  return null;
}
